import {useGtm} from '@gtm-support/vue-gtm';
import {useRoute} from 'vue-router';
import {storeToRefs} from 'pinia';
import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
import {useVisitedHypermarket} from '~/composables/useVisitedHypermarket';

export function useLeafletTracking(leaflet: Ref, gtmPageType: Ref) {
	const gtm = useGtm();
	const route = useRoute();
	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarketInstance} = storeToRefs(hypermarketsStore);
	const {visitedHypermarketInstance} = useVisitedHypermarket();

	function createBasePayload(extras?: Record<string, any>) {
		return {
			name: leaflet.value?.actionOfferName,
			parameter: leaflet.value?.slug,
			id_letaku: leaflet.value?.actionOfferId,
			selected_hypermarket: selectedHypermarketInstance.value?.content.name,
			content_hypermarket: visitedHypermarketInstance.value?.content.name,
			page_type: gtmPageType.value,
			...extras,
		};
	}

	function trackPageView(totalPages: number) {
		gtm?.push({
			event: 'leaflet_page_view',
			...createBasePayload({
				content: totalPages,
				target: `${window.location.origin}${route.fullPath}`,
			}),
		});
	}

	function trackDownload() {
		gtm?.push({
			event: 'leaflet_download',
			...createBasePayload(),
		});
	}

	function trackScrollProgress(progress: number, currentPage: number, totalPages: number, currentImageAsset?: string) {
		gtm?.push({
			event: 'leaflet_scroll',
			...createBasePayload({
				percent: progress,
				counter: currentPage,
				content: totalPages,
				target: `${window.location.origin}${route.fullPath}`,
				...(currentImageAsset && {target: currentImageAsset}),
			}),
		});
	}

	function trackPageShowtime(pageIndex: number, visibilitySeconds: number, viewCount: number, totalPages: number, currentImageAsset?: string) {
		gtm?.push({
			event: 'leaflet_list_showtime',
			...createBasePayload({
				number: visibilitySeconds,
				action: viewCount,
				content: totalPages,
				counter: pageIndex,
				...(currentImageAsset && {target: currentImageAsset}),
			}),
		});
	}

	return {
		trackPageView,
		trackDownload,
		trackScrollProgress,
		trackPageShowtime,
	};
}
